<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import TokenBalanceCard from './TokenBalanceCard.vue'
import TokenRecentTransactions from './TokenRecentTransactions.vue'

defineProps<{
  walletAddress?: string
  totalTokens?: number
  propertiesCount?: number
}>()

const emit = defineEmits<{
  (e: 'view-all-transactions'): void
}>()
</script>

<template>
  <Box align="start" gap="6" class="twb">
    <TokenBalanceCard
      :wallet-address="walletAddress"
      :total-tokens="totalTokens"
      :properties-count="propertiesCount"
    />
    <TokenRecentTransactions @view-all="emit('view-all-transactions')" />
  </Box>
</template>

<style scoped>
.twb {
  width: 100%;
}

.twb > :first-child {
  flex: 1;
}

.twb > :last-child {
  flex: 1;
}

@media (max-width: 992px) {
  .twb {
    flex-direction: column;
  }
}
</style>
